import { render, staticRenderFns } from "./ProzessCustomFields.vue?vue&type=template&id=4cd3157d&scoped=true"
import script from "./ProzessCustomFields.vue?vue&type=script&lang=js"
export * from "./ProzessCustomFields.vue?vue&type=script&lang=js"
import style0 from "./ProzessCustomFields.vue?vue&type=style&index=0&id=4cd3157d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd3157d",
  null
  
)

export default component.exports